/**
 * Instantiate Accordion
 * @param  {Node}       wrapper Dom class or dom node
 * @param  {Object}     options Object holding optional parameters
 * @return {undefined}
 */
export default class Accordion{
  constructor( wrapper, options = {} ){
    /** Check if wrapper is already dom element */
    if(wrapper instanceof Element || wrapper instanceof HTMLDocument){
      this.wrapperDOM = wrapper;
    }else{
      this.wrapperDOM = document.querySelector(wrapper);
    }
    if(!this.wrapperDOM) throw new Error('You must specify accordion wrapper!');

    this.item   = options.item    || '.accordion__item';
    this.toggle = options.toggle  || '.accordion__toggle';
    this.body   = options.body    || '.accordion__body';
    this.itemsDOM = this.wrapperDOM.querySelectorAll(this.item);
		this.collapse = this.wrapperDOM.getAttribute('data-collapse') || true;

    this.init();

    this.boundActivateEvent;

    this._bindEvents();
  }

  _bindEvents() {
    this.boundActivateEvent = (event) => this._activate(event);
    this.itemsDOM.forEach(item => {
      let toggle = item.querySelector(this.toggle);
      toggle.addEventListener('click', this.boundActivateEvent);
    })

    window.addEventListener('resize', event => {
      this.init();
    });
  }

  /** Call this method whenever accordion item has been added */
  /** Removes existing click event and adds new one */
  recache() {
    this.itemsDOM = this.wrapperDOM.querySelectorAll(this.item);
    this.itemsDOM.forEach(item => {
      let toggle = item.querySelector(this.toggle);
      toggle.removeEventListener('click', this.boundActivateEvent)
      toggle.addEventListener('click', this.boundActivateEvent)
    })
  }

  init() {
    this.itemsDOM.forEach(item => {
      // console.log(item);
      let body = item.querySelector(this.body);
      body.style.height = 'auto';
      body.dataset.naturalHeight = body.offsetHeight;
      body.style.height = (item.classList.contains('is-active')) ? `${body.dataset.naturalHeight}px` : 0;
    });
  }

  _activate( event ) {
    const toggle = event.currentTarget;

    this.itemsDOM.forEach(item => {
      if (item.contains(toggle)) {
        let body = item.querySelector(this.body);
        body.style.height = (item.classList.contains('is-active')) ? 0 : `${body.dataset.naturalHeight}px`;
        item.classList.toggle('is-active');

        toggle.setAttribute('aria-expanded', !(toggle.getAttribute('aria-expanded') === 'true'));
        // if (toggle.getAttribute('aria-expanded') === 'true')  toggle.setAttribute('aria-expanded', false);
        // else                                                  toggle.setAttribute('aria-expanded', true);
      }
      else {
        if (this.collapse) {
          let body = item.querySelector(this.body);
          body.style.height = 0;
          item.classList.remove('is-active');
        }
      }
    });
	}
}
